import global from "@/locales/da-DK/global";
import error403 from "@/locales/da-DK/errors/403";
import error404 from "@/locales/da-DK/errors/404";
import error500 from "@/locales/da-DK/errors/500";
import error503 from "@/locales/da-DK/errors/503";
import error504 from "@/locales/da-DK/errors/504";
import maintenance from "@/locales/da-DK/auth/maintenance";
import toast from "@/locales/da-DK/toast/toast";
import login from "@/locales/da-DK/auth/login";
import onboarding from "@/locales/da-DK/auth/onboarding";
import loginPageSteps from "@/locales/da-DK/loginPageSteps";
import dashboard from "@/locales/da-DK/dashboard/dashboard";
import account from "@/locales/da-DK/account/account";
import mailbox from "@/locales/da-DK/account/mailbox";
import bankstatement from "@/locales/da-DK/account/bankstatement";
import myApps from "@/locales/da-DK/my-apps/myApps";
import about from "@/locales/da-DK/about/about";
import contactService from "@/locales/da-DK/about/contactService";
import salesPromotions from "@/locales/da-DK/sales/promotions";
import brochures from "@/locales/da-DK/sales/brochures";
import shop from "@/locales/da-DK/shop/data";
import priceList from "@/locales/da-DK/shop/priceList";
import staff from "@/locales/da-DK/dashboard/staff";
import promotions from "@/locales/da-DK/promotions";
import points from "@/locales/da-DK/points";
import trainings from "@/locales/da-DK/trainings/trainings";
import vouchers from "@/locales/da-DK/vouchers/vouchers";
import widgets from "@/locales/da-DK/widgets/widgets";
import generateReport from "@/locales/da-DK/generate-report/generateReport";
import wholesaler from "@/locales/da-DK/wholesaler/wholesaler";
import media from "@/locales/da-DK/media/index";
import product from "@/locales/da-DK/product/index";
import message from "@/locales/da-DK/message/index";
import commitmentLetter from "@/locales/da-DK/account/commitmentLetter";
import multiplicator from "@/locales/da-DK/multiplicator";
import consents from "@/locales/da-DK/consents/consents";
import investment from "@/locales/da-DK/investment/data";
import kickback from "@/locales/da-DK/kickback";

//prettier-ignore
const messages = {
  loginPageSteps: loginPageSteps.messages,
  global: global.messages,
  error403: error403.messages,
  error404: error404.messages,
  error500: error500.messages,
  error503: error503.messages,
  error504: error504.messages,
  maintenance: maintenance.messages,
  toast: toast.messages,
  login: login.messages,
  onboarding: onboarding.messages,
  dashboard: dashboard.messages,
  multiplicator: multiplicator.messages,
  account: account.messages,
  mailbox: mailbox.messages,
  myApps: myApps.messages,
  bankstatement: bankstatement.messages,
  about: about.messages,
  contactService: contactService.messages,
  salesPromotions: salesPromotions.messages,
  shop: shop.messages,
  staff: staff.messages,
  promotions: promotions.messages,
  points: points.messages,
  brochures: brochures.messages,
  trainings: trainings.messages,
  vouchers: vouchers.messages,
  generateReport: generateReport.messages,
  widgets: widgets.messages,
  wholesaler: wholesaler.messages,
  media: media.messages,
  priceList: priceList.messages,
  productInfo: product.messages,
  message: message.messages,
  commitmentLetter: commitmentLetter.messages,
  consents: consents.messages,
  investment: investment.messages,
  kickback: kickback.messages,
  productBrochures: {
    BDriveTitle: "Produktbilleder",
    BDriveLinkText: "Link til portalen med PRODUKTBILLEDER",
  },
}

export default {
  locale: "da-DK",
  messages,
};
